import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';

export const distributeGroupsHorizonticallyMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Distribute groups horizontally',
		isVisible: ({ controller, context, refMap }): boolean => {
			// const refMap = controller?.kitchen?.getReferenceMap(context.id);
			// not available in overhead view
			if (controller?.navigation.displayMode === DisplayMode.Overhead) return false;

			// item must be panel or have a panel parent
			if (controller.readonly || (refMap?.panel ?? null) === null) return false;

			return true;
		},
		onClick: ({ refMap }): void => {
			// const refMap = controller?.kitchen?.getReferenceMap(context.id);
			if (refMap?.panel) refMap.panel.distributeApplianceGroupsHorizontally();
		}
	};
};
